export default {
  default: () => import("/home/forge/dreamjobs.hu/layouts/default.vue").then(m => m.default || m)
}